import { toastWarning } from "../toasts/toast";

export default function validaData(dataDevolvendo) {

  if (dataDevolvendo === "") {
    toastWarning("Defina uma data");
    return true;
  }

  const dataDoDia = new Date();
  dataDoDia.setHours(0, 0, 0, 0);

  const dataEscolhida = new Date(dataDevolvendo + "T00:00:00");

  if (dataEscolhida < dataDoDia) {
    toastWarning("Data inválida");
    return true;
  }

  return false;
}
